import GetCheckoutSvg, {
  CheckoutIcons,
} from "../checkout-icons/GetCheckoutSvg";

interface Props {
  svg?: CheckoutIcons;
  mobile: boolean;
  title: string;
  withoutBorder?: boolean;
  customAction?: React.ReactNode;
  fontSize?: number;
}

const CheckoutBoxHeader: React.FC<Props> = ({
  svg,
  mobile,
  title,
  withoutBorder,
  customAction,
  fontSize,
}) => {
  return (
    <div
      className="checkout-box-header"
      style={withoutBorder ? { border: "none" } : {}}
    >
      <h4 className="title m-0" style={{ fontSize }}>
        {svg && <GetCheckoutSvg svg={svg} mobile={mobile} />}
        {title}
      </h4>

      {customAction && <div>{customAction}</div>}
    </div>
  );
};

export default CheckoutBoxHeader;
